import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Typo from 'uikit/content/components/typo';

import { Link } from 'react-router-dom';

import styles from '../styles/uikitManageManagePageNav.module.scss';

const ManagePageNav = ({ activeId = '', items }) => (
  <nav className={styles.element}>
    <ul className={styles.navList}>
      {items.map(({ id = '', onClick = () => {}, testId = '', title = '', to = '' }) => (
        <li
          data-testid={testId || `manage-page-nav-item-${id}`}
          className={styles.navListItem}
          key={id.toString() || testId}
        >
          {typeof title === 'string' ? (
            <Link
              className={classnames(styles.navLink, { [styles.isActive]: id === activeId })}
              data-object-name={`${title} Tab`}
              onClick={() => onClick(id)}
              id={id}
              to={to}
            >
              <Typo element="div" variant="b01" weight="medium">
                {title}
              </Typo>
            </Link>
          ) : (
            title
          )}
        </li>
      ))}
    </ul>
  </nav>
);

ManagePageNav.propTypes = {
  activeId: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onClick: PropTypes.func,
      testId: PropTypes.string,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      to: PropTypes.string,
    }),
  ).isRequired,
};

export default ManagePageNav;
